"use client";

import { useEffect } from "react";

interface TrustedShopsProps {
  disableResponsive?: boolean;
  attachToId?: string;
}

const TrustedShops: React.FC<TrustedShopsProps> = ({
  disableResponsive = true,
  attachToId,
}) => {
  useEffect(() => {
    // Check if element already exists or target element is missing
    if (!attachToId && document.querySelector("#trustedShops") != null) return;
    if (attachToId && !document.querySelector(`#${attachToId}`)) return;

    const _tsid = "X655DB37A1A3D4DEE0F0D2C415DBCB30B";

    // Create and append TrustedShops script with modern data attributes
    const scriptTag = document.createElement("script");
    scriptTag.type = "text/javascript";
    scriptTag.id = attachToId || "trustedShops";
    scriptTag.async = true;
    scriptTag.src = `//widgets.trustedshops.com/js/${_tsid}.js`;

    // Add modern data attributes for configuration
    scriptTag.setAttribute("data-desktop-enable-fadeout", "true");
    if (!disableResponsive) {
      scriptTag.setAttribute("data-disable-mobile", "false");
    }

    if (document.head) {
      document.head.appendChild(scriptTag);
    }

    // Cleanup function to remove script and widget when component unmounts
    return () => {
      const existingScript = document.getElementById(
        attachToId || "trustedShops"
      );
      existingScript?.parentNode?.removeChild(existingScript);
      // Remove the floating badge widget injected by the TrustedShops script
      const badgeContainer = document.getElementById(
        "trustbadge-container-98e3dadd90eb493088abdc5597a70810"
      );
      badgeContainer?.parentNode?.removeChild(badgeContainer);
    };
  }, [attachToId, disableResponsive]);

  return null;
};

export default TrustedShops;
